import React from "react";
import { Dialog, Button, DialogActions, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { assets } from "./../assets/assets";
import content from "./../assets/content.json";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function InfoModal({language, instruction, handleInstructionClose }) {
  const currentAssets = assets[language]
  const currentLanguage = content[language]["content"]

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"lg"}
      PaperProps={{
        style: {
          borderRadius: 3,
          boxShadow: "0 0 0 5px #333",
          minHeight: "20vh",
          minWidth: "30%",
        },
      }}
      open={instruction}
      TransitionComponent={Transition}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <img
        src={currentAssets.instructionImage}
        alt="instruction"
        width={"100%"}
      />
      <DialogActions sx={{ bgcolor: "#081627", color: "#FFC627", padding: 0 }}>
        <Button
          onClick={handleInstructionClose}
          sx={{
            m: 0,
            minWidth: 0,
            position: "absolute",
            right: 24,
            top: 24,
            color: "#FFC627",
            backgroundColor: "rgba(255, 198, 39, 0.2);",
            "&:hover": { backgroundColor: "#FFC627", color: "#000" },
          }}
          aria-label={currentLanguage["alt-close_instructions"]}
        >
          <CloseIcon />
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default InfoModal;
